export const type = 'form.dataGrid';
